/**
 * @generated SignedSource<<0d04c477d795d7c55fab5aa55606814f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespCondensedContainer_viewer$data = {
  readonly similarItemsGrid?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly serviceId: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsGrid_similarItems">;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespCondensedListedContent_viewer" | "PdpRespDealerChatLoader_viewer" | "PdpRespSimilarItemsGrid_viewer" | "PdpSharedFeaturedRelatedItemsCarouselLazy_viewer" | "PdpSharedSellerItemsCarousel_viewer">;
  readonly " $fragmentType": "PdpRespCondensedContainer_viewer";
};
export type PdpRespCondensedContainer_viewer$key = {
  readonly " $data"?: PdpRespCondensedContainer_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespCondensedContainer_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplayAndBtNone"
    },
    {
      "kind": "RootArgument",
      "name": "fetchPdp"
    },
    {
      "kind": "RootArgument",
      "name": "isClient"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespCondensedContainer_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGrid_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespCondensedListedContent_viewer"
    },
    {
      "condition": "fetchPdp",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedSellerItemsCarousel_viewer"
        },
        {
          "alias": "similarItemsGrid",
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 16
            },
            {
              "kind": "Variable",
              "name": "itemId",
              "variableName": "itemId"
            },
            {
              "kind": "Literal",
              "name": "seller",
              "value": "EXCLUDE"
            },
            {
              "kind": "Literal",
              "name": "useML",
              "value": true
            }
          ],
          "concreteType": "moreLikeThisItemConnection",
          "kind": "LinkedField",
          "name": "moreLikeThisItem",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "moreLikeThisItemEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Item",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "serviceId",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "PdpRespSimilarItemsGrid_similarItems"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespDealerChatLoader_viewer"
        }
      ]
    },
    {
      "condition": "afterDisplayAndBtNone",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedFeaturedRelatedItemsCarouselLazy_viewer"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "a1c8e32135bb1252e0d5c50fef4dd90f";

export default node;
